import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';
import { ProService } from '../db/models/pro-services';
import { ProfiledService } from '../db/models/profiled-service';

@Injectable({
  providedIn: 'root'
})
export class ProfessionalServiceService {

  // private baseUrl = 'https://localhost:44352/api/service/';
  private baseUrl = 'https://api.trepezserver.com/api/service/';


  headers = new HttpHeaders()
  .set('Content-Type','application/json')
  .set('Access-Control-Allow-Origin','*')
  .set('X-Requested-With', 'XMLHttpRequest')

constructor(private http: HttpClient) { }

getAllProfessionalServices(): Observable<ProService[]> {
  return this.http.get<ProService[]>(this.baseUrl + 'services')
}

createProfessionalService(data: ProService): Observable<ProService> {
  // const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
  return this.http.post<ProService>(this.baseUrl + 'newService', data, { 'headers': this.headers });
}

RegisterService(data: ProService): Observable<ProService> {
  // const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
  return this.http.post<ProService>(this.baseUrl + 'RegisterService', data, { 'headers': this.headers });
}

updateService(data: ProService): Observable<ProService> {
  return this.http.post<ProService>(this.baseUrl + 'modifyService/' + data.id, data, { 'headers': this.headers });
}

getserviceDetail(id:string): Observable<ProService>{
  return this.http.get<ProService>(this.baseUrl + 'service/' + id)
}

}
